import { normalizeLayout } from './normalize-layout'

export const normalizeBaseHome = (rawData) => {
  return {
    description: rawData?.description ?? '',
    version: rawData?.version ?? '',
    type: rawData?.type ?? '',
    id: rawData?.id ?? '',
    layout: normalizeLayout(rawData?.layout ?? {}),
  }
}
